// extracted by mini-css-extract-plugin
module.exports = {"App":"src-App--2lsLZ","fade":"src-App--U3W2J","animate__animated":"src-App--2IJCx","fadeIn":"src-App--Gli4_","in":"src-App--2rnTK"};